import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';
import { Relation } from '../../../../types/Rules';

import styles from '../../voucher-form.module.scss';

interface VoucherFormRelationsProps {
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onRelationTypeChange: (value: Relation | '') => void;
  relationType: Relation | '';
}

const VoucherFormRelations: React.FC<VoucherFormRelationsProps> = ({
  disabled = false,
  onRelationTypeChange,
  relationType,
}) => {
  return (
    <div className={styles.inputLarge}>
      <Select
        id='relations'
        value={relationType}
        disabled={disabled}
        onChange={e => onRelationTypeChange(e.target.value as Relation)}
        label='Relations'
        placeholder='Select one of the options'
      >
        <SelectOption value='allowed_countries'>Allowed country relations</SelectOption>
        <SelectOption value='forbidden_countries'>Forbidden country relations</SelectOption>
      </Select>
    </div>
  );
};

export default VoucherFormRelations;
